"use client";

import { Box } from "@mui/material";
import { paper, text } from "@rmh/ds";
import Image from "next/image";
import type { ReactNode } from "react";
import { LanguageSwitcher } from "./LanguageSwitcher";

interface OnboardingHeaderProps {
  stepper?: ReactNode;
  action?: ReactNode;
}

export const OnboardingHeader = ({
  stepper,
  action,
}: OnboardingHeaderProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
    <Box
      component="header"
      sx={{
        backgroundColor: paper["14-staticDark"].dark,
        color: text.staticWhite.light,
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
        gap: 2,
        paddingX: { xs: 2, md: 8 },
        paddingY: { xs: 2, md: 3 },
      }}
    >
      <Image
        src="/images/rightmove/rightmove-logo-full-light.png"
        alt="RightMove"
        width={146}
        height={28}
        priority
      />
      <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
        {action && (
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 4,
            }}
          >
            {action}
          </Box>
        )}
        <LanguageSwitcher />
      </Box>
    </Box>
    {stepper}
  </Box>
);
